export const SEARCH_TEMPLATE_CS_ENTRY_ID = 'BASE_RULE';
export const DEFAULT_USER_STATE = 'WA';
